import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/layout/PublicLayout";

import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import LocationPage from "@/pages/LocationPage";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminLocations from "@/pages/admin/AdminLocations";
import AdminBuilders from "@/pages/admin/AdminBuilders";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminSettings from "@/pages/admin/AdminSettings";

const Public = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Public><Home /></Public>} />
              <Route path="/properties" element={<Public><Properties /></Public>} />
              <Route path="/property/:slug" element={<Public><PropertyDetail /></Public>} />
              <Route path="/:seoSlug" element={<Public><LocationPage /></Public>} />
              <Route path="/about" element={<Public><About /></Public>} />
              <Route path="/services" element={<Public><Services /></Public>} />
              <Route path="/blog" element={<Public><Blog /></Public>} />
              <Route path="/blog/:slug" element={<Public><BlogPost /></Public>} />
              <Route path="/contact" element={<Public><Contact /></Public>} />
              <Route path="/thank-you" element={<Public><ThankYou /></Public>} />
              <Route path="/legal/:page" element={<Public><Legal /></Public>} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="projects" element={<AdminProjects />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="locations" element={<AdminLocations />} />
                <Route path="builders" element={<AdminBuilders />} />
                <Route path="team" element={<AdminTeam />} />
                <Route path="blogs" element={<AdminBlogs />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              <Route path="*" element={<Public><NotFound /></Public>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
